import ('./style.scss')

import StackedChart from './stacked-chart'

export default StackedChart